import React from 'react'
import styled from 'styled-components'
import { FormattedMessage } from 'react-intl'

export const RewardsCard = ({ title, columnTitle, bottomLabel, rewardsData }) => {
  return (
    <CardContainer>
      <div className='top-title'>
        <p className='top-copy'>{title}</p>
        <p className='bottom-copy'>Rewards</p>
      </div>
      <div className='center-content'>
        <table className='rewards-table'>
          <thead>
            <tr>
              <th className='first-th' dangerouslySetInnerHTML={{ __html: columnTitle }}></th>
              <th className='second-th'>Reward</th>
            </tr>
          </thead>
          <tbody>
            {rewardsData &&
              rewardsData.map((row, index) => (
                <React.Fragment key={index}>
                  <tr className='data-row'>
                    <td>{row.columnOne}</td>
                    <td>{row.columnTwo}</td>
                  </tr>
                  <tr style={{ backgroundColor: '#fff', height: 5 }}></tr>
                </React.Fragment>
              ))}
          </tbody>
        </table>
      </div>
      <div className='bottom-label'>
        <FormattedMessage id={bottomLabel} />
      </div>
    </CardContainer>
  )
}

const CardContainer = styled.div`
  border: 5px solid var(--zls-accent-primary-color);
  width: 100%;
  height: 320px;
  padding: 10px 20px;

  .top-title {
    text-transform: uppercase;
    color: var(--zls-primary-surface);
    font-weight: 300;

    .top-copy {
      font-size: 35px;
      margin: 0;
      padding: 0;
    }
    .bottom-copy {
      font-size: 20px;
      margin-top: -20px;
      padding: 0;
    }
  }
  .center-content {
    display: flex;
    justify-content: center;

    .rewards-table {
      width: 100%;
      thead {
        text-align: center;
        .first-th {
          color: var(--zls-primary-surface);
          text-align: center;
          font-size: 12px;
          word-wrap: break-word;
          line-height: 1;
          font-weight: 300;
        }
        .second-th {
          color: var(--zls-primary-surface);
          text-transform: uppercase;
        }
      }
      tbody {
        border-collapse: separate;
        border-spacing: 0 10px;
        .data-row {
          background-color: var(--zls-primary-surface);
          color: #fff;
          font-size: 14px;
        }
      }
    }
  }
  .bottom-label {
    color: var(--zls-accent-primary-color);
    text-align: center;
    font-size: 12px;
  }
`
